// The rider's week: what the planner builds around. Every rider has one from the start, a stated
// guess until they set it, so nothing about any one rider lives in the code.
import type { Standing, State, YourWeek } from "./types";
import { addDays, daysBetween } from "./dates.ts";

const WORK: [string, string] = ["09:00", "17:30"];

/** The guess before the rider says: work Monday to Friday, 09:00 to 17:30; Tuesday and Thursday
 * evenings and a Saturday long ride. Older settings (finish times, kept evenings) carry over. */
export function defaultWeek(st: State["settings"]): YourWeek {
  const kept = st.keptEvenings ?? [];
  const days = [0, 1, 2, 3, 4, 5, 6].map((i) => {
    const sunFirst = (i + 1) % 7;
    const d: YourWeek["days"][number] = { ride: i === 1 || i === 3 ? "evening" : "no", work: i < 5 ? [WORK[0], WORK[1]] : null };
    if (kept.includes(sunFirst)) d.kept = "Kept evening";
    return d;
  });
  return {
    days, longDay: 5, longStart: "09:00",
    morningOut: "06:00", morningDoneBy: st.morningFinishBy ?? "08:45",
    eveningOut: "18:30", eveningDoneBy: st.latestFinish ?? "21:30",
    outMin: st.bufferMin ?? 20, standing: [], guessed: true,
  };
}

export const weekOf = (s: { settings: State["settings"] }): YourWeek => s.settings.week ?? defaultWeek(s.settings);

/** Whether a standing ride runs in the week of this Monday (every other week counts from its first). */
export function standingRuns(r: Standing, monday: string): boolean {
  if (r.every !== 2 || !r.from) return true;
  const weeks = Math.floor(daysBetween(r.from, addDays(monday, r.day)) / 7);
  return ((weeks % 2) + 2) % 2 === 0;
}
